
export default {
    props: {
        defaultValue: {
              default(){
                  return "";
              }
        },
        id: {
            default() {
                return "camera";
            }
        },
    },

    data(){
        return {
            active: false,
            title: "",
            link: "",
        }
    },


    methods: {
        change() {
            this.active = false;

            this.$emit("change", {
                title: this.title,
                link: this.link,
                html : `<a href="${this.link}">${this.title}</a>`
            });
        },
    },

}
